
























































































import { Component, Vue } from "vue-property-decorator";
import Country from "@/store/entities/country";
import City from "@/store/entities/city";
import Airport from "@/store/entities/flight/airport";
@Component({})
export default class AddCity extends Vue {
  dialog: boolean = true;
  countries: Country[] = [];
  country: Country = new Country();
  city: City = new City();
  selectedCountry:Country = new Country();
  isEdit: boolean = false;
  isValid: boolean = false;

  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
        dropdown: (value) => !!value.id || "Zorunlu Alan.",
      },
    };
  }

  async created() {
    await this.getCountries();

    this.city = this.$store.state.city.editCity;
    debugger;
    if (this.city == null) {
      this.isEdit = false;
      this.city = new City();
    } else {
      this.isEdit = true;
      let countryId = this.city.countryId;
      this.country = this.countries.find((x) => x.id == countryId);
      this.getCountries().then((x) => {
        this.selectedCountry = this.countries.find(
          (x) => x.id == this.city.countryId
        );
      });
    }
  }

  async saveCity() {
    this.city.countryId = this.country.id;

    if (!this.isEdit) {
      await this.$store.dispatch({
        type: "city/saveCity",
        data: this.city,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: "city/saveCity",
        data: this.city,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }

  async getCountries() {
    await this.$store.dispatch({
      type: "country/getCountries",
    });
    this.countries = this.$store.state.country.list;
  }



  closeDialog() {
    this.$emit("closed");
    this.$store.state.airport.editAirport = null;
  }

  cancelDialog() {
    this.$emit("cancel");
    this.$store.state.airport.editAirport = null;
  }
}
